import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingModule } from '../loading/loading.module';
import { LocationContextPanelModule } from '../location-context-panel/location-context-panel.module';
import { MaterialModule } from '../material/material.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { Pages } from '../pages.config';
import { TimeCounterModule } from '../time-counter/time-counter.module';
import { FlightsComponent } from './flights/flights.component';
import { FlightsResolver } from './resolvers/flights.resolver';
import { FlightsEffects } from './store/flights.effects';
import * as fromFlights from './store/flights.reducers';

const flightsRoutes: Routes = [
    { path: Pages.flights.path, component: FlightsComponent, resolve: { FlightsResolver } },
    { path: '**', component: FlightsComponent, resolve: { FlightsResolver } }
];

@NgModule({
    declarations: [FlightsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        LoadingModule,
        LocationContextPanelModule,
        TimeCounterModule,
        NotificationsModule,
        RouterModule.forChild(flightsRoutes),
        StoreModule.forFeature(fromFlights.flightsFeatureKey, fromFlights.flightsReducer, {
            metaReducers: fromFlights.metaReducers
        }),
        EffectsModule.forFeature([FlightsEffects])
    ],
    exports: [FlightsComponent],
    providers: [FlightsResolver]
})
export class FlightsModule {}
